import { UseQueryResult, useMutation, useQuery } from '@tanstack/react-query';
import { IMetric } from '@src/emp-3.0/types';

import { METRIC_LIST_QUERY_KEY } from '../constants';
import { getMetricList, postCoverageReport } from './query';

export const useGetMetricList = (preferredVersion?: string): UseQueryResult<IMetric[], unknown> => {
  return useQuery([METRIC_LIST_QUERY_KEY, preferredVersion], async () => {
    const res = await getMetricList(preferredVersion);
    return res?.data?.data;
  });
};

export const useCoverageReport = () => {
  return useMutation(async (payload: any) => {
    const res = await postCoverageReport(payload);
    return res.data.data;
  });
};
